<footer
  role="contentinfo"
  [attr.aria-label]="ariaLabel()"
  [attr.id]="id()"
  [attr.tabindex]="tabIndex()"
  [attr.title]="title()"
  [ngClass]="cssClasses()"
  [style]="cssStyle()">
  <div class="hx-footer__container">
    @if (showLogo()) {
      <div class="hx-footer__logo">
        <hx-logo
          cssClass="hx-footer__logo-component"
          [clickable]="logoClickable()"
          [hoverEffect]="true"
          [product]="productType()"
          [size]="logoSize()"
          [type]="logoType()"
          [variant]="logoVariant()"
          (logoClick)="onLogoClick()" />
      </div>
    }

    <div class="hx-footer__content">
      <ng-content />
    </div>
  </div>
</footer>
